import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import MenuIcon from "@material-ui/icons/Menu";
import Icon from "@material-ui/core/Icon";
import AccountCircle from "@material-ui/icons/AccountCircle";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import NavLink from "./NavLink";
import { Router, Link, Redirect, navigate } from "@reach/router";
import SvgIcon from "@material-ui/core/SvgIcon";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MoreVertIcon from "@material-ui/icons/MoreVert";

import NavTabs from "./NavTabs";
import { navContent } from "./config";
import SERVER_ADDRESS from "../../config";

import { AccountMenu } from "./accountmenu";
const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 2
  },

  menuButton: {
    marginLeft: -12,
    marginRight: 20
  },
  button: {
    margin: theme.spacing(1)
  },
  appbar: {
    marginBottom: 1,
    height: "60px"
  }
}));

function MobileLogo(props) {
  return (
    <IconButton color="inherit" disableRipple>
      <Icon>
        <SvgIcon>
          <path d="M165 183l0-37-37 0 0 37z m0 219l0-36-37 0 0 36z m219 0l0-36-37 0 0 36z m-293-292l110 0 0 109-110 0z m0 219l110 0 0 110-110 0z m220 0l110 0 0 110-110 0z m-73-73l0-183-183 0 0 183z m146-146l0-37-37 0 0 37z m73 0l0-37-36 0 0 37z m0 146l0-110-110 0 0 37-36 0 0-110-37 0 0 183 110 0 0-37 37 0 0 37z m-219 219l0-182-183 0 0 182z m219 0l0-182-183 0 0 182z" />
        </SvgIcon>
      </Icon>
    </IconButton>
  );
}

function MobileMenu(props) {
  const classes = useStyles();
  const fullList = (
    <List>
      {navContent.map(({ label, link }) => (
        <ListItem button component={Link} to={"/" + link} key={label}>
          <ListItemText primary={label} />
        </ListItem>
      ))}
    </List>
  );
  const [open, setOpen] = useState(false);
  const toggleDrawer = drawerStatus => () => {
    setOpen(drawerStatus);
  };
  return (
    <>
      <SwipeableDrawer
        anchor="top"
        open={open}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
      >
        <div
          role="button"
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
        >
          {fullList}
        </div>
      </SwipeableDrawer>

      <IconButton
        color="inherit"
        aria-label="Menu"
        onClick={toggleDrawer(true)}
      >
        <MenuIcon />
      </IconButton>
    </>
  );
}

function DeskTopLogo(props) {
  const classes = useStyles();

  return (
    <Hidden mdDown>
      <Typography variant="h6" color="inherit" className={classes.grow}>
        清官式大木作虚拟仿真教学实验
      </Typography>
    </Hidden>
  );
}

//Main Component
function NavBar(props) {
  //get parseData nav from url
  const { nav } = props;

  const classes = useStyles();

  return (
    <>
      <AppBar position="fixed" className={classes.appbar}>
        <Toolbar>
          <Hidden lgUp>
            <div className={classes.grow}>
              <MobileMenu />
            </div>
          </Hidden>

          <DeskTopLogo />
          <Hidden mdDown>
            <NavTabs navLocation={nav} />
          </Hidden>
          <AccountMenu />
        </Toolbar>
      </AppBar>
      <div className={classes.appbar} />
    </>
  );
}

export default NavBar;
